<template>
    <section class="bg-white text-center py-16 px-4 mt-20">
      <!-- Título principal -->
      <h2 class="text-2xl md:text-4xl font-semibold mb-4">
        Pessoas e empresas como você já fazem parte do nosso time!
      </h2>
  
      <!-- Subtítulo -->
      <p class="text-gray-500 mb-8">
        Atuamos a mais de 20 anos no mercado com mais de 25000 clientes ativos!
      </p>
  
      <!-- Estrelas -->
      <div class="flex justify-center mb-8">
        <template v-for="i in 5" :key="i">
          <svg class="w-8 h-8 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.2 3.68h3.872c.969 0 1.371 1.24.588 1.81l-3.13 2.27 1.2 3.68c.3.921-.755 1.688-1.54 1.118l-3.13-2.27-3.13 2.27c-.784.57-1.838-.197-1.539-1.118l1.2-3.68-3.13-2.27c-.784-.57-.38-1.81.588-1.81h3.872l1.2-3.68z"/>
          </svg>
        </template>
      </div>
  
      <!-- Ícone de aspas -->
      <div class="text-gray-300 text-4xl mb-4">“</div>
  
      <!-- Texto do depoimento -->
      <p class="max-w-4xl mx-auto text-gray-800 text-base md:text-lg mb-6 leading-relaxed">
        Nossa missão é ser a melhor empresa de gerenciamento e hospedagem de conteúdo para o ambiente WEB com todo o suporte necessários que permita aos nossos clientes o máximo das vantagens competitivas ao seu negócio.
      </p>
  
      <!-- Assinatura -->
      <p class="text-sm text-gray-500 font-medium">Equipe Integrator</p>
    </section>
  </template>
  